module.exports = __webpack_public_path__ + "img/cash-refund.e976ad2b.svg";